"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dtoErrors = void 0;
const empty = undefined;
/**
 * Dictionary object for specific field errors which can be thrown
 * when validating a data transfer object.
 *
 * The error messages are undefined by default which causes the class-validator
 * to determine the message. You can alter the object before importing the data
 * transfer objects to alter the error messages.
 */
exports.dtoErrors = {
    attendance: {
        userId: { isNotEmpty: empty, isMongoId: empty },
        locationId: { isNotEmpty: empty, isMongoId: empty },
        attendedAt: { isDateString: empty },
    },
    credentials: {
        email: { isEmail: empty, isNotEmpty: empty },
        password: { isNotEmpty: empty, isString: empty },
    },
    forgotPassword: {
        token: { isNotEmpty: empty, isString: empty },
        expiresAt: { isDateString: empty },
        userId: { isMongoId: empty },
    },
    forgotPasswordRedemption: {
        token: { isString: empty, isNotEmpty: empty },
        password: { isNotEmpty: empty, isString: empty },
    },
    forgotPasswordRequest: {
        email: { isNotEmpty: empty, isEmail: empty },
    },
    group: {
        name: { isNotEmpty: empty, isString: empty },
        memberIds: { isMongoId: empty },
        volunteerIds: { isMongoId: empty },
        locationId: { isMongoId: empty, isNotEmpty: empty },
    },
    groupNote: {
        body: { isNotEmpty: empty, isString: empty },
        groupId: { isMongoId: empty, isNotEmpty: empty },
        authorId: { isMongoId: empty, isNotEmpty: empty },
        sessionDate: { isDateString: empty },
    },
    location: {
        name: { isString: empty, isNotEmpty: empty },
        address: { isString: empty },
        city: { isString: empty },
        state: { isString: empty },
        postalCode: { isString: empty },
        country: { isIso31661Alpha2: empty },
    },
    model: {
        id: { isMongoId: empty },
        _id: { isMongoId: empty },
        createdAt: { isDateString: empty },
        updatedAt: { isDateString: empty },
    },
    sessionToken: {
        token: { isNotEmpty: empty, isString: empty },
        lastValidation: { isDateString: empty },
        userId: { isMongoId: empty },
    },
    user: {
        email: { isEmail: empty },
        gender: { isEnum: empty },
        countryOfOrigin: { isIso31661Alpha2: empty },
        password: { isString: empty },
        role: { isEnum: empty },
        firstName: { isNotEmpty: empty, isString: empty },
        lastName: { isString: empty },
        yearOfBirth: { isNumber: empty },
        attendedAt: { isDateString: empty },
        numberOfAttendances: { isNumber: empty },
        volunteerLocationIds: { isMongoId: empty },
        locationIds: { isMongoId: empty },
    },
};
//# sourceMappingURL=dto-errors.constant.js.map